import React, { memo, PropsWithChildren } from 'react'
import LiveStrategyBuilderPayoffEffects from './liveStrategyBuilderPayoffEffects'

/** Thin shell so tab children (e.g. option chain) are not re-rendered when trade orders change. */
const LiveStrategyBuilderContainer: React.FC<PropsWithChildren> = ({ children }) => (
    <>
        <LiveStrategyBuilderPayoffEffects />
        {children}
    </>
)

export default memo(LiveStrategyBuilderContainer)
